import { render, staticRenderFns } from "./Textarea.vue?vue&type=template&id=1416c8ae&scoped=true&lang=pug&"
import script from "./Textarea.vue?vue&type=script&lang=js&"
export * from "./Textarea.vue?vue&type=script&lang=js&"
import style1 from "./Textarea.vue?vue&type=style&index=1&id=1416c8ae&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1416c8ae",
  null
  
)

export default component.exports